export const IntegrationTypeEnum = {
  GUPSHUP: 'gupshup',
  DIALOG: 'dialog',
  TALLOS: 'tallos',
}
  